/**
 * GENERATED - run `npm run style-spec:restore` to restore the original.
 */

const dataConstantEnum = {
  'type': 'enum',
  'values': {
    'visible': {},
    'none': {},
  },
  'default': 'visible',
  'expression': {
    'interpolated': false,
    'parameters': ['global-state'],
  },
  'property-type': 'data-constant',
};

const dataDrivenNumber = {
  'type': 'number',
  'expression': {
    'interpolated': false,
    'parameters': ['zoom', 'feature'],
  },
  'property-type': 'data-driven',
};

const dataConstantBoolean = {
  'type': 'boolean',
  'default': false,
  'expression': {
    'interpolated': false,
    'parameters': ['zoom'],
  },
  'property-type': 'data-constant',
};

const dataDrivenEnum = {
  'type': 'enum',
  'values': {
    'center': {},
    'left': {},
    'right': {},
    'top': {},
    'bottom': {},
    'top-left': {},
    'top-right': {},
    'bottom-left': {},
    'bottom-right': {},
  },
  'default': 'center',
  'expression': {
    'interpolated': false,
    'parameters': ['zoom', 'feature'],
  },
  'property-type': 'data-driven',
};

const dataDrivenArray = {
  'type': 'array',
  'value': 'number',
  'length': 2,
  'default': [0, 0],
  'expression': {
    'interpolated': true,
    'parameters': ['zoom', 'feature'],
  },
  'property-type': 'data-driven',
};

const dataConstantEnum2 = {
  'type': 'enum',
  'values': {
    'never': {},
    'always': {},
    'cooperative': {},
  },
  'expression': {
    'interpolated': false,
    'parameters': ['zoom'],
  },
  'property-type': 'data-constant',
};

const dataConstantEnum3 = {
  'type': 'enum',
  'values': {
    'map': {},
    'viewport': {},
    'auto': {},
  },
  'default': 'auto',
  'expression': {
    'interpolated': false,
    'parameters': ['zoom'],
  },
  'property-type': 'data-constant',
};

const dataDrivenNumber2 = {
  'type': 'number',
  'default': 0,
  'expression': {
    'interpolated': true,
    'parameters': ['zoom', 'feature'],
  },
  'property-type': 'data-driven',
};

const dataConstantBoolean2 = {
  'type': 'boolean',
  'default': true,
  'expression': {
    'interpolated': false,
    'parameters': ['zoom'],
  },
  'property-type': 'data-constant',
};

const dataConstantColor = {
  'type': 'color',
  'default': '#000000',
  'expression': {
    'interpolated': true,
    'parameters': ['zoom'],
  },
  'property-type': 'data-constant',
};

const dataConstantNumber = {
  'type': 'number',
  'default': 1,
  'expression': {
    'interpolated': true,
    'parameters': ['zoom'],
  },
  'property-type': 'data-constant',
};

const dataDrivenNumber3 = {
  'type': 'number',
  'default': 0,
  'expression': {
    'interpolated': true,
    'parameters': ['zoom', 'feature', 'feature-state'],
  },
  'property-type': 'data-driven',
};

const dataDrivenColor = {
  'type': 'color',
  'default': '#000000',
  'expression': {
    'interpolated': true,
    'parameters': ['zoom', 'feature', 'feature-state'],
  },
  'property-type': 'data-driven',
};

const dataDrivenNumber4 = {
  'type': 'number',
  'default': 1,
  'expression': {
    'interpolated': true,
    'parameters': ['zoom', 'feature', 'feature-state'],
  },
  'property-type': 'data-driven',
};

const dataConstantEnum4 = {
  'type': 'enum',
  'values': {
    'map': {},
    'viewport': {},
  },
  'default': 'viewport',
  'expression': {
    'interpolated': false,
    'parameters': ['zoom'],
  },
  'property-type': 'data-constant',
};

const dataConstantEnum5 = {
  'type': 'enum',
  'values': {
    'map': {},
    'viewport': {},
  },
  'default': 'map',
  'expression': {
    'interpolated': false,
    'parameters': ['zoom'],
  },
  'property-type': 'data-constant',
};

const dataConstantArray = {
  'type': 'array',
  'value': 'number',
  'length': 2,
  'default': [0, 0],
  'expression': {
    'interpolated': true,
    'parameters': ['zoom'],
  },
  'property-type': 'data-constant',
};

const dataConstantEnum6 = {
  'type': 'enum',
  'values': {
    'linear': {},
    'nearest': {},
  },
  'default': 'linear',
  'expression': {
    'interpolated': false,
    'parameters': ['zoom'],
  },
  'property-type': 'data-constant',
};

const dataConstantNumber2 = {
  'type': 'number',
  'default': 1,
  'expression': {
    'interpolated': true,
    'parameters': ['zoom', 'global-state'],
  },
  'property-type': 'data-constant',
};

const crossFadedDataDrivenResolvedimage = {
  'type': 'resolvedImage',
  'expression': {
    'interpolated': false,
    'parameters': ['zoom', 'feature'],
  },
  'property-type': 'cross-faded-data-driven',
};

const dataConstantNumber3 = {
  'type': 'number',
  'default': 0,
  'expression': {
    'interpolated': true,
    'parameters': ['zoom'],
  },
  'property-type': 'data-constant',
};

const dataDrivenColor2 = {
  'type': 'color',
  'default': 'rgba(0, 0, 0, 0)',
  'expression': {
    'interpolated': true,
    'parameters': ['zoom', 'feature', 'feature-state'],
  },
  'property-type': 'data-driven',
};

export default {
  'layout_background': {
    'visibility': {...dataConstantEnum},
  },
  'layout_circle': {
    'circle-sort-key': {...dataDrivenNumber},
    'visibility': {...dataConstantEnum},
  },
  'layout_color-relief': {
    'visibility': {...dataConstantEnum},
  },
  'layout_fill': {
    'fill-sort-key': {...dataDrivenNumber},
    'visibility': {...dataConstantEnum},
  },
  'layout_fill-extrusion': {
    'fill-extrusion-rounded-corner-distance': {
      'type': 'number',
      'default': 0,
      'property-type': 'constant',
    },
    'visibility': {...dataConstantEnum},
  },
  'layout_heatmap': {
    'visibility': {...dataConstantEnum},
  },
  'layout_hillshade': {
    'visibility': {...dataConstantEnum},
  },
  'layout_line': {
    'line-cap': {
      'type': 'enum',
      'values': {
        'butt': {},
        'round': {},
        'square': {},
      },
      'default': 'butt',
      'expression': {
        'interpolated': false,
        'parameters': ['zoom', 'feature'],
      },
      'property-type': 'data-driven',
    },
    'line-join': {
      'type': 'enum',
      'values': {
        'bevel': {},
        'round': {},
        'miter': {},
      },
      'default': 'miter',
      'expression': {
        'interpolated': false,
        'parameters': ['zoom', 'feature'],
      },
      'property-type': 'data-driven',
    },
    'line-miter-limit': {
      'type': 'number',
      'default': 2,
      'expression': {
        'interpolated': true,
        'parameters': ['zoom', 'feature'],
      },
      'property-type': 'data-driven',
    },
    'line-round-limit': {
      'type': 'number',
      'default': 1.05,
      'expression': {
        'interpolated': true,
        'parameters': ['zoom', 'feature'],
      },
      'property-type': 'data-driven',
    },
    'line-sort-key': {...dataDrivenNumber},
    'visibility': {...dataConstantEnum},
  },
  'layout_raster': {
    'visibility': {...dataConstantEnum},
  },
  'layout_symbol': {
    'icon-allow-overlap': {...dataConstantBoolean},
    'icon-anchor': {...dataDrivenEnum},
    'icon-ignore-placement': {...dataConstantBoolean},
    'icon-image': {
      'type': 'resolvedImage',
      'tokens': true,
      'expression': {
        'interpolated': false,
        'parameters': ['zoom', 'feature'],
      },
      'property-type': 'data-driven',
    },
    'icon-keep-upright': {...dataConstantBoolean},
    'icon-offset': {...dataDrivenArray},
    'icon-optional': {...dataConstantBoolean},
    'icon-overlap': {...dataConstantEnum2},
    'icon-padding': {
      'type': 'padding',
      'default': [2],
      'expression': {
        'interpolated': true,
        'parameters': ['zoom', 'feature'],
      },
      'property-type': 'data-driven',
    },
    'icon-pitch-alignment': {...dataConstantEnum3},
    'icon-rotate': {...dataDrivenNumber2},
    'icon-rotation-alignment': {
      'type': 'enum',
      'values': {
        'map': {},
        'viewport': {},
        'auto': {},
      },
      'default': 'auto',
      'expression': {
        'interpolated': false,
        'parameters': ['zoom', 'feature'],
      },
      'property-type': 'data-driven',
    },
    'icon-size': {
      'type': 'number',
      'default': 1,
      'expression': {
        'interpolated': true,
        'parameters': ['zoom', 'feature'],
      },
      'property-type': 'data-driven',
    },
    'icon-text-fit': {
      'type': 'enum',
      'values': {
        'none': {},
        'width': {},
        'height': {},
        'both': {},
      },
      'default': 'none',
      'expression': {
        'interpolated': false,
        'parameters': ['zoom'],
      },
      'property-type': 'data-constant',
    },
    'icon-text-fit-padding': {
      'type': 'array',
      'value': 'number',
      'length': 4,
      'default': [0, 0, 0, 0],
      'expression': {
        'interpolated': true,
        'parameters': ['zoom'],
      },
      'property-type': 'data-constant',
    },
    'symbol-avoid-edges': {...dataConstantBoolean},
    'symbol-height-anchor': {
      'type': 'enum',
      'values': {
        'ground': {},
        'absolute': {},
      },
      'default': 'ground',
      'expression': {
        'interpolated': false,
        'parameters': ['zoom'],
      },
      'property-type': 'data-constant',
    },
    'symbol-height-offset': {...dataDrivenNumber2},
    'symbol-placement': {
      'type': 'enum',
      'values': {
        'point': {},
        'line': {},
        'line-center': {},
      },
      'default': 'point',
      'expression': {
        'interpolated': false,
        'parameters': ['zoom'],
      },
      'property-type': 'data-constant',
    },
    'symbol-sort-key': {...dataDrivenNumber},
    'symbol-spacing': {
      'type': 'number',
      'default': 250,
      'expression': {
        'interpolated': true,
        'parameters': ['zoom'],
      },
      'property-type': 'data-constant',
    },
    'symbol-z-order': {
      'type': 'enum',
      'values': {
        'auto': {},
        'viewport-y': {},
        'source': {},
      },
      'default': 'auto',
      'expression': {
        'interpolated': false,
        'parameters': ['zoom'],
      },
      'property-type': 'data-constant',
    },
    'text-allow-overlap': {...dataConstantBoolean},
    'text-anchor': {...dataDrivenEnum},
    'text-field': {
      'type': 'formatted',
      'default': '',
      'tokens': true,
      'expression': {
        'interpolated': false,
        'parameters': ['zoom', 'feature'],
      },
      'property-type': 'data-driven',
    },
    'text-font': {
      'type': 'array',
      'value': 'string',
      'default': ['Open Sans Regular', 'Arial Unicode MS Regular'],
      'expression': {
        'interpolated': false,
        'parameters': ['zoom', 'feature'],
      },
      'property-type': 'data-driven',
    },
    'text-ignore-placement': {...dataConstantBoolean},
    'text-justify': {
      'type': 'enum',
      'values': {
        'auto': {},
        'left': {},
        'center': {},
        'right': {},
      },
      'default': 'center',
      'expression': {
        'interpolated': false,
        'parameters': ['zoom', 'feature'],
      },
      'property-type': 'data-driven',
    },
    'text-keep-upright': {...dataConstantBoolean2},
    'text-letter-spacing': {...dataDrivenNumber2},
    'text-line-height': {
      'type': 'number',
      'default': 1.2,
      'expression': {
        'interpolated': true,
        'parameters': ['zoom'],
      },
      'property-type': 'data-constant',
    },
    'text-max-angle': {
      'type': 'number',
      'default': 45,
      'expression': {
        'interpolated': true,
        'parameters': ['zoom'],
      },
      'property-type': 'data-constant',
    },
    'text-max-width': {
      'type': 'number',
      'default': 10,
      'expression': {
        'interpolated': true,
        'parameters': ['zoom', 'feature'],
      },
      'property-type': 'data-driven',
    },
    'text-offset': {...dataDrivenArray},
    'text-optional': {...dataConstantBoolean},
    'text-overlap': {...dataConstantEnum2},
    'text-padding': {
      'type': 'number',
      'default': 2,
      'expression': {
        'interpolated': true,
        'parameters': ['zoom'],
      },
      'property-type': 'data-constant',
    },
    'text-pitch-alignment': {...dataConstantEnum3},
    'text-radial-offset': {
      'type': 'number',
      'default': 0,
      'property-type': 'data-driven',
      'expression': {
        'interpolated': true,
        'parameters': ['zoom', 'feature'],
      },
    },
    'text-rotate': {...dataDrivenNumber2},
    'text-rotation-alignment': {
      'type': 'enum',
      'values': {
        'map': {},
        'viewport': {},
        'viewport-glyph': {},
        'auto': {},
      },
      'default': 'auto',
      'expression': {
        'interpolated': false,
        'parameters': ['zoom'],
      },
      'property-type': 'data-constant',
    },
    'text-size': {
      'type': 'number',
      'default': 16,
      'expression': {
        'interpolated': true,
        'parameters': ['zoom', 'feature'],
      },
      'property-type': 'data-driven',
    },
    'text-transform': {
      'type': 'enum',
      'values': {
        'none': {},
        'uppercase': {},
        'lowercase': {},
      },
      'default': 'none',
      'expression': {
        'interpolated': false,
        'parameters': ['zoom', 'feature'],
      },
      'property-type': 'data-driven',
    },
    'text-variable-anchor': {
      'type': 'array',
      'value': 'enum',
      'values': {
        'center': {},
        'left': {},
        'right': {},
        'top': {},
        'bottom': {},
        'top-left': {},
        'top-right': {},
        'bottom-left': {},
        'bottom-right': {},
      },
      'expression': {
        'interpolated': false,
        'parameters': ['zoom'],
      },
      'property-type': 'data-constant',
    },
    'text-variable-anchor-offset': {
      'type': 'variableAnchorOffsetCollection',
      'expression': {
        'interpolated': true,
        'parameters': ['zoom', 'feature'],
      },
      'property-type': 'data-driven',
    },
    'text-writing-mode': {
      'type': 'array',
      'value': 'enum',
      'values': {
        'horizontal': {},
        'vertical': {},
      },
      'expression': {
        'interpolated': false,
        'parameters': ['zoom'],
      },
      'property-type': 'data-constant',
    },
    'visibility': {...dataConstantEnum},
  },
  'paint_background': {
    'background-color': {...dataConstantColor},
    'background-opacity': {...dataConstantNumber},
    'background-pattern': {
      'type': 'resolvedImage',
      'expression': {
        'interpolated': false,
        'parameters': ['zoom'],
      },
      'property-type': 'cross-faded',
    },
  },
  'paint_circle': {
    'circle-blur': {...dataDrivenNumber3},
    'circle-color': {...dataDrivenColor},
    'circle-opacity': {...dataDrivenNumber4},
    'circle-pitch-alignment': {...dataConstantEnum4},
    'circle-pitch-scale': {...dataConstantEnum5},
    'circle-radius': {
      'type': 'number',
      'default': 5,
      'expression': {
        'interpolated': true,
        'parameters': ['zoom', 'feature', 'feature-state'],
      },
      'property-type': 'data-driven',
    },
    'circle-stroke-color': {...dataDrivenColor},
    'circle-stroke-opacity': {...dataDrivenNumber4},
    'circle-stroke-width': {...dataDrivenNumber3},
    'circle-translate': {...dataConstantArray},
    'circle-translate-anchor': {...dataConstantEnum5},
  },
  'paint_color-relief': {
    'color-relief-color': {
      'type': 'color',
      'expression': {
        'interpolated': true,
        'parameters': ['elevation'],
      },
      'property-type': 'color-ramp',
    },
    'color-relief-opacity': {...dataConstantNumber},
    'resampling': {...dataConstantEnum6},
  },
  'paint_fill': {
    'fill-antialias': {...dataConstantBoolean2},
    'fill-color': {...dataDrivenColor},
    'fill-layer-opacity': {...dataConstantNumber2},
    'fill-opacity': {...dataDrivenNumber4},
    'fill-outline-color': {
      'type': 'color',
      'expression': {
        'interpolated': true,
        'parameters': ['zoom', 'feature', 'feature-state'],
      },
      'property-type': 'data-driven',
    },
    'fill-pattern': {...crossFadedDataDrivenResolvedimage},
    'fill-translate': {...dataConstantArray},
    'fill-translate-anchor': {...dataConstantEnum5},
  },
  'paint_fill-extrusion': {
    'fill-extrusion-base': {...dataDrivenNumber3},
    'fill-extrusion-color': {...dataDrivenColor},
    'fill-extrusion-height': {...dataDrivenNumber3},
    'fill-extrusion-opacity': {...dataConstantNumber},
    'fill-extrusion-pattern': {...crossFadedDataDrivenResolvedimage},
    'fill-extrusion-translate': {...dataConstantArray},
    'fill-extrusion-translate-anchor': {...dataConstantEnum5},
    'fill-extrusion-vertical-gradient': {...dataConstantBoolean2},
  },
  'paint_heatmap': {
    'heatmap-color': {
      'type': 'color',
      'default': [
        'interpolate',
        ['linear'],
        ['heatmap-density'],
        0,
        'rgba(0, 0, 255, 0)',
        0.1,
        'royalblue',
        0.3,
        'cyan',
        0.5,
        'lime',
        0.7,
        'yellow',
        1,
        'red',
      ],
      'expression': {
        'interpolated': true,
        'parameters': ['heatmap-density'],
      },
      'property-type': 'color-ramp',
    },
    'heatmap-intensity': {...dataConstantNumber},
    'heatmap-opacity': {...dataConstantNumber},
    'heatmap-radius': {
      'type': 'number',
      'default': 30,
      'expression': {
        'interpolated': true,
        'parameters': ['zoom', 'feature', 'feature-state'],
      },
      'property-type': 'data-driven',
    },
    'heatmap-weight': {...dataDrivenNumber4},
  },
  'paint_hillshade': {
    'hillshade-accent-color': {...dataConstantColor},
    'hillshade-exaggeration': {
      'type': 'number',
      'default': 0.5,
      'expression': {
        'interpolated': true,
        'parameters': ['zoom'],
      },
      'property-type': 'data-constant',
    },
    'hillshade-highlight-color': {
      'type': 'colorArray',
      'default': '#FFFFFF',
      'expression': {
        'interpolated': true,
        'parameters': ['zoom'],
      },
      'property-type': 'data-constant',
    },
    'hillshade-illumination-altitude': {
      'type': 'numberArray',
      'default': 45,
      'expression': {
        'interpolated': true,
        'parameters': ['zoom'],
      },
      'property-type': 'data-constant',
    },
    'hillshade-illumination-anchor': {...dataConstantEnum4},
    'hillshade-illumination-direction': {
      'type': 'numberArray',
      'default': 335,
      'expression': {
        'interpolated': true,
        'parameters': ['zoom'],
      },
      'property-type': 'data-constant',
    },
    'hillshade-method': {
      'type': 'enum',
      'values': {
        'standard': {},
        'basic': {},
        'combined': {},
        'igor': {},
        'multidirectional': {},
      },
      'default': 'standard',
      'expression': {
        'interpolated': false,
        'parameters': ['zoom'],
      },
      'property-type': 'data-constant',
    },
    'hillshade-shadow-color': {
      'type': 'colorArray',
      'default': '#000000',
      'expression': {
        'interpolated': true,
        'parameters': ['zoom'],
      },
      'property-type': 'data-constant',
    },
    'resampling': {...dataConstantEnum6},
  },
  'paint_line': {
    'line-blur': {...dataDrivenNumber3},
    'line-color': {...dataDrivenColor},
    'line-dasharray': {
      'type': 'array',
      'value': 'number',
      'expression': {
        'interpolated': false,
        'parameters': ['zoom', 'feature'],
      },
      'property-type': 'cross-faded-data-driven',
    },
    'line-gap-width': {...dataDrivenNumber3},
    'line-gradient': {
      'type': 'color',
      'expression': {
        'interpolated': true,
        'parameters': ['line-progress'],
      },
      'property-type': 'color-ramp',
    },
    'line-layer-opacity': {...dataConstantNumber2},
    'line-offset': {...dataDrivenNumber3},
    'line-opacity': {...dataDrivenNumber4},
    'line-pattern': {...crossFadedDataDrivenResolvedimage},
    'line-translate': {...dataConstantArray},
    'line-translate-anchor': {...dataConstantEnum5},
    'line-width': {...dataDrivenNumber4},
  },
  'paint_raster': {
    'raster-brightness-max': {...dataConstantNumber},
    'raster-brightness-min': {...dataConstantNumber3},
    'raster-contrast': {...dataConstantNumber3},
    'raster-fade-duration': {
      'type': 'number',
      'default': 300,
      'expression': {
        'interpolated': true,
        'parameters': ['zoom'],
      },
      'property-type': 'data-constant',
    },
    'raster-hue-rotate': {...dataConstantNumber3},
    'raster-opacity': {...dataConstantNumber},
    'raster-resampling': {...dataConstantEnum6},
    'raster-saturation': {...dataConstantNumber3},
    'resampling': {...dataConstantEnum6},
  },
  'paint_symbol': {
    'icon-color': {...dataDrivenColor},
    'icon-halo-blur': {...dataDrivenNumber3},
    'icon-halo-color': {...dataDrivenColor2},
    'icon-halo-width': {...dataDrivenNumber3},
    'icon-opacity': {...dataDrivenNumber4},
    'icon-translate': {...dataConstantArray},
    'icon-translate-anchor': {...dataConstantEnum5},
    'text-color': {...dataDrivenColor},
    'text-halo-blur': {...dataDrivenNumber3},
    'text-halo-color': {...dataDrivenColor2},
    'text-halo-width': {...dataDrivenNumber3},
    'text-opacity': {...dataDrivenNumber4},
    'text-translate': {...dataConstantArray},
    'text-translate-anchor': {...dataConstantEnum5},
  },
};
